
import { defineComponent, PropType } from 'vue'

import { ReportCopyTextT, ReportMeta, ReportPageT } from '~/types/reportTypes'
import { ReportLevel, ReportType } from '~/types/types'
import { smartApostrophe } from '~/utils/string'
import { getDefaultAvatar } from '~/utils/ui'

/**
 * Public Report Child page
 */
export default defineComponent({
  name: 'PublicReportPageWrapper',
  props: {
    level: {
      type: String as PropType<ReportLevel>,
      required: true
    },
    ownerLogin: {
      type: String,
      required: true
    },
    ownerLogo: {
      type: String,
      default: ''
    },
    createdAt: {
      type: String,
      required: true
    },
    reportKey: {
      type: String as PropType<ReportPageT>,
      required: true
    },
    isReportReady: {
      type: Boolean
    },
    reportId: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      ReportType,
      switchToFallback: false
    }
  },
  computed: {
    copyText(): ReportCopyTextT {
      return (
        ReportMeta[this.reportKey].copyText(this.ownerLogin) ?? { summary: '', intendedUse: '' }
      )
    },
    label(): string {
      return ReportMeta[this.reportKey].title ? `${ReportMeta[this.reportKey].title} report` : ''
    }
  },
  methods: {
    smartApostrophe,
    getDefaultAvatar
  }
})
